module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fABc4AMP6lbBP.f7625d37.woff2";